import { useState } from 'react'
import { Outlet, NavLink } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

function useSidebar() {
  const [open, setOpen] = useState(() => localStorage.getItem('admin_sidebar_open') !== 'false')
  const toggle = () => setOpen(o => {
    localStorage.setItem('admin_sidebar_open', !o)
    return !o
  })
  return [open, toggle]
}

function LogoutModal({ onConfirm, onCancel }) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal animate-scale-in" style={{ maxWidth: 380 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ borderBottom: '1px solid var(--border)', paddingBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 40, height: 40, borderRadius: 10,
              background: 'rgba(239,68,68,0.1)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 20
            }}>🚪</div>
            <div>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)' }}>Cerrar sesión</h3>
              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 2 }}>Panel Super Admin</p>
            </div>
          </div>
        </div>
        <div className="modal-body" style={{ padding: '20px 24px' }}>
          <p style={{ fontSize: 14, color: 'var(--text-soft)', lineHeight: 1.6 }}>
            ¿Estás seguro que deseas cerrar la sesión de administrador?
          </p>
        </div>
        <div className="modal-footer" style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', padding: '0 24px 20px' }}>
          <button className="btn" onClick={onCancel} style={{ minWidth: 100 }}>Cancelar</button>
          <button className="btn btn-danger" onClick={onConfirm} style={{ minWidth: 120 }}>Sí, cerrar sesión</button>
        </div>
      </div>
    </div>
  )
}

const ITEMS = [
  { ruta: '/admin/dashboard', icono: '📊', label: 'Dashboard' },
  { ruta: '/admin/empresas',  icono: '🏢', label: 'Empresas'  },
  { ruta: '/admin/planes',    icono: '💰', label: 'Planes'    },
  { ruta: '/admin/vps',       icono: '🖥️', label: 'Monitor VPS' },
]

export default function AdminLayout() {
  const { superAdmin, logout } = useAuth()
  const [open, toggleSidebar] = useSidebar()
  const [showLogout, setShowLogout] = useState(false)

  return (
    <div className="app-shell">

      {/* ── Sidebar Admin ── */}
      <nav className={`sidenav admin-sidenav${open ? ' open' : ''}`}>

        {/* Header */}
        <div className="sidenav-head">
          <div className="sidenav-brand">
            <div className="sidenav-brand-logo" style={{ background: '#1e293b' }}>
              <span style={{ fontSize: 18 }}>👑</span>
            </div>
            <span className="sidenav-brand-name">Super Admin</span>
          </div>
          <button className="sidenav-toggle" onClick={toggleSidebar} title={open ? 'Colapsar' : 'Expandir'}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d={open ? 'M9 2L4 7l5 5' : 'M5 2l5 5-5 5'}
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Nav items */}
        <div className="sidenav-scroll">
          <div className="sidenav-section">Gestión</div>
          {ITEMS.map(item => (
            <NavLink
              key={item.ruta}
              to={item.ruta}
              className={({ isActive }) => `sidenav-item${isActive ? ' active' : ''}`}
            >
              <span className="sidenav-icon">{item.icono}</span>
              <span className="sidenav-label">{item.label}</span>
              <span className="tooltip">{item.label}</span>
            </NavLink>
          ))}
        </div>

        {/* Footer */}
        <div className="sidenav-footer">
          <button className="sidenav-item" onClick={() => setShowLogout(true)} title="Cerrar sesión">
            <span className="sidenav-icon">🚪</span>
            <span className="sidenav-label">Cerrar sesión</span>
            <span className="tooltip">Cerrar sesión</span>
          </button>
        </div>
      </nav>

      {/* Modal logout */}
      {showLogout && (
        <LogoutModal onConfirm={logout} onCancel={() => setShowLogout(false)} />
      )}

      {/* Main content */}
      <div className="main-content">
        <div className="topbar admin-topbar">
          <div className="flex items-center gap-3">
            <span style={{ fontSize: 16 }}>👑</span>
            <span className="topbar-title">Panel Super Admin</span>
          </div>
          <div className="topbar-actions">
            <div className="avatar avatar-sm" style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }} title={superAdmin?.nombre}>
              {(superAdmin?.nombre || 'S')[0].toUpperCase()}
            </div>
            <span className="text-sm text-soft">{superAdmin?.nombre}</span>
            <span className="badge" style={{ background: 'rgba(245,158,11,0.15)', color: '#d97706', border: '1px solid rgba(245,158,11,0.3)' }}>
              superadmin
            </span>
          </div>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
